import { whoUses } from '@/mocks/features';

export default function WhoUses() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Our Community
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Who Uses Vigorbuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            From fashion enthusiasts to smart shoppers, our platform serves a diverse community of product lovers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {whoUses.map((user) => (
            <div
              key={user.id}
              className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-accent-200 transition-all duration-200"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${user.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                  {user.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {user.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}